import styled from "styled-components";

const Input = styled.input`
    padding: 0.5em;    
    margin: 0.5em;    
    color: palevioletred;
    background: papayawhip;
    border: none;
    border-radious: 3px;
`;

export default Input;


// WEBPACK FOOTER //
// ./src/components/Input.js